class Invoice {
	constructor() {
		this.invoice_number = ''
		this.invoice_date = null
		this.invoice_amount = null

		this.invoice_document = null
		this.bilty_document = null

		this.dkt_documents = null
		this.tc_received_document = null
		this.tc_updated_document = null

		// ADDED MISSING KEYS

		this.original_invoice_number = null
		this.oracle_invoice_internal_id = null
		this.customer_original_so_number = null
		this.oracle_so_number = null

		this.delivery_date = null
		this.gps_link = null
		this.invoice_status = null
		this.delivery_status = null

		this.customer_tax_reg_number = null
		this.vendor_tax_reg_number = null
		this.mb_subsidiary_tax_number = null

		this.invoice_due_date = null
		this.posting_period = null
		this.created_date = null
		this.tax_point_date = null

		this.sub_total_amount = null
		this.tax_total = null
		this.cgst = null
		this.sgst = null
		this.igst = null

		this.due_balance_amount = null

		this.currency = null
		this.exchange_rate = null
		this.vendor_bill_no = [] 
		this.supplier_id = null
		this.remarks = null
		this.account_details = null

		this.eway_bill_document = null
		this.delivery_receipt = null
		this.other_documents = [] 
		this.product_photos = [] 

		this.order_items = [] 
		this.vehicle_number = null
		this.driver_number = null
		this.trip_id = null

		this.export_documents = []

		this.total_serviced_weight = null
		this.rejected_weight = null

		// charges
		this.freight_charge = null
		this.cutting_charge = null
		this.pickling_charge = null
		this.insurance = null
		this.packaging_charge = null
		this.slitting_charge = null
		this.other_charge = null
		this.packing_charge = null
		this.pmi_charge = null
		this.loading_charge = null
		this.unloading_charge = null
		this.oiling_and_pickling_charges = null
		this.transport_detention_charge = null
		this.tcs_charge = null

		this.dispatch_location = null

		this.payment_terms = null
		this.e_way_details = null
		this.ship_date = null

		this.irn_no = null
		this.irn_ack_no = null
		this.irn_ack_date = null

		this.invoice_ext_cost = null
		this.invoice_gross_profit = null
		this.invoice_gross_profit_percentage = null

		this.tnc = null

		this.receiver_details = null

		this.pod_message_triggered = false
	}
}

export default Invoice
